import React, {useCallback, useEffect,useMemo,useState,} from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../style/custommillingHubdashboard.css";
import "../../../../style/customresponsivefile.css";
import "../../../../style/addrestoration.css";
import "../../../../style/addmaterial.css";
import { getStatusStyle } from "../../../../utils/statusStyles";
import { ManagerScheduledOrder,ClinicOption } from "../Interfaces/ScheduleOrders";
import { apiAxios } from "../../../../utils/apiAxios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
const API_BASE = process.env.REACT_APP_API_BASE_URL;


const STATUS_ITEMS = [
  { key: "Active Orders", icon: null, iconClass: null },
  {
    key: "Awaiting Response",
    icon: "../../awaiting.png",
    iconClass: null,
  },
  {
    key: "Needs Attention",
    icon: "../../needsattantion2.png",
    iconClass: null,
  },
  {
    key: "On Time",
    icon: "../../completed.png",
    iconClass: null,
  },
  {
    key: "Completed",
    icon: null,
    iconClass: "bi bi-check-circle-fill completed-icon",
  },
  {
    key: "Cancelled",
    icon: null,
    iconClass: "bi bi-dash-circle-fill",
  },
];


const formatScheduleDate = (date?: string | null): string => {
  if (!date || date === "-") return "--";

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) return date;

  return parsedDate.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatScheduleTime = (time?: string | null): string => {
  if (!time || time === "-") return "--";

  const match = time.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);

  if (match) {
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    const seconds = Number(match[3] ?? 0);

    if (hours > 23 || minutes > 59 || seconds > 59) return time;

    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const parsedDate = new Date(time);

  if (Number.isNaN(parsedDate.getTime())) return time;

  return parsedDate.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};



const formatDateTime = (dateTime?: string | null): string => {
  if (!dateTime || dateTime === "-") return "--";

  const date = new Date(dateTime);

  if (Number.isNaN(date.getTime())) return dateTime;

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const toNumber = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatFilterDate = (date: Date | null): string | undefined => {
  if (!date) return undefined;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const mapScheduledOrder = (item: any): ManagerScheduledOrder => ({
  id: toNumber(item.id ?? item.caseID ?? item.CaseID),
  caseID: toNumber(item.caseID ?? item.CaseID),

  orderId: item.orderId ?? item.orderID ?? item.OrderID ?? "--",
  type: item.type ?? item.orderTypeName ?? item.OrderTypeName ?? "--",

  scheduleDate: item.scheduleDate ?? item.ScheduleDate ?? "",
  scheduleTime: item.scheduleTime ?? item.ScheduleTime ?? "",
  scheduleEndTime: item.scheduleEndTime ?? item.ScheduleEndTime ?? "",

  status: item.status ?? item.Status ?? "--",

  clinic:
    item.clinic ??
    item.clinicName ??
    item.ClinicName ??
    "--",

  clinicMobileNo:
    item.clinicMobileNo ??
    item.ClinicMobileNo ??
    "--",

  clinicAddress:
    item.clinicAddress ??
    item.ClinicAddress ??
    "--",

  paymentStatus:
    item.paymentStatus ??
    item.PaymentStatus ??
    "--",

  originalAmount: toNumber(
    item.originalAmount ??
      item.OriginalAmount ??
      item.amount ??
      item.Amount
  ),

  discountAmount: toNumber(
    item.discountAmount ?? item.DiscountAmount
  ),

  couponPercentage: toNumber(
    item.couponPercentage ?? item.CouponPercentage
  ),

  paidAmount: toNumber(
    item.paidAmount ?? item.PaidAmount
  ),

  createdTime:
    item.createdTime ??
    item.CreatedTime ??
    "",
});

const OrderStatusContent: React.FC<{
  orderDetails: ManagerScheduledOrder;
}> = ({ orderDetails }) => {
  const timeline = [
    {
      time: orderDetails.createdTime,
      event: "Order Created",
      status: "Created",
    },
    {
      time: orderDetails.createdTime,
      event: (
        <div>
          <div>
            <strong>Payment Successful</strong>
          </div>

          <div className="small text-muted mt-1">
            <div>Original Amount: ₹{orderDetails.originalAmount}</div>
            <div>Discount Amount: ₹{orderDetails.discountAmount}</div>
            <div>Coupon: {orderDetails.couponPercentage}% Off</div>
            <div>
              <strong>Paid Amount: ₹{orderDetails.paidAmount}</strong>
            </div>
          </div>
        </div>
      ),
      status: orderDetails.paymentStatus || "Pending",
    },
  ];

  return (
    <div className="row g-0 p-3">
      <div className="col-md-6 pe-md-4 border-end" style={{ minWidth: 0 }}>
        <ul className="list-unstyled order-status-list delivery-type-section">
          <li className="time-event-section-delivery-type mt-1">
            <strong className="strongtext-fontweight Delivery-Type-text">
              Payment Status
            </strong>
            <span>{orderDetails.paymentStatus || "--"}</span>
          </li>

          <li className="time-event-section-delivery-type mt-1">
            <strong className="strongtext-fontweight Delivery-Type-text">
              Schedule Date
            </strong>
            <span>{formatScheduleDate(orderDetails.scheduleDate)}</span>
          </li>

          <li className="time-event-section-delivery-type mt-1">
            <strong className="strongtext-fontweight Delivery-Type-text">
              Schedule Time
            </strong>
            <span>
              {formatScheduleTime(orderDetails.scheduleTime)}
              {orderDetails.scheduleEndTime &&
                ` – ${formatScheduleTime(orderDetails.scheduleEndTime)}`}
            </span>
          </li>

          <li className="time-event-section-delivery-type mt-1">
            <strong className="strongtext-fontweight Delivery-Type-text">
              Order Type
            </strong>
            <span>{orderDetails.type || "--"}</span>
          </li>
        </ul>

        <div className="accordion mt-3" id="managerOrderStatusAccordion">
          <div className="accordion-item border rounded p-2 mt-3">
            <h2 className="accordion-header">
              <button
                type="button"
                className="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#managerClinicDetails"
                aria-expanded="true"
                aria-controls="managerClinicDetails"
              >
                <strong className="strongtext-fontweight Delivery-Type-text">
                  Clinic
                </strong>
              </button>
            </h2>

            <div
              id="managerClinicDetails"
              className="accordion-collapse collapse show"
              data-bs-parent="#managerOrderStatusAccordion"
            >
              <div className="accordion-body">
                <div className="doctor-name-bottom">
                  {orderDetails.clinic || "--"}
                </div>

                <div className="doctor-name-bottom">
                  {orderDetails.clinicMobileNo || "--"}
                </div>

                <div className="doctor-name-bottom">
                  {orderDetails.clinicAddress || "--"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6 ps-md-4" style={{ minWidth: 0 }}>
        <ul className="list-unstyled order-status-timeline">
          <li
            className="time-event-section border-bottom pb-2 mb-2"
            style={{
              display: "grid",
              gridTemplateColumns: "100px minmax(0, 1fr) 90px",
              gap: "6px",
              fontWeight: 600,
            }}
          >
            <span>Time</span>
            <span>Event</span>
            <span>Status</span>
          </li>

          {timeline.map((item, index) => (
            <li
              key={index}
              className="time-event-section mb-3"
              style={{
                display: "grid",
                gridTemplateColumns: "100px minmax(0, 1fr) 90px",
                alignItems: "start",
                columnGap: "6px",
              }}
            >
              <strong
                className="strongtext-fontweight Delivery-Type-text"
                style={{
                  fontSize: "12px",
                  lineHeight: "1.35",
                  overflowWrap: "anywhere",
                }}
              >
                {formatDateTime(item.time)}
              </strong>

              <div
                style={{
                  fontSize: "12px",
                  lineHeight: "1.35",
                  minWidth: 0,
                  overflowWrap: "anywhere",
                }}
              >
                {item.event}
              </div>

              <span
                className="status-part"
                style={{
                  fontSize: "12px",
                  lineHeight: "1.35",
                  overflowWrap: "anywhere",
                }}
              >
                {item.status || "--"}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const ScheduleOrders: React.FC = () => {
  const [orders, setOrders] = useState<ManagerScheduledOrder[]>([]);
  const [showRefundModal, setShowRefundModal] = useState(false);
const [selectedCancellation, setSelectedCancellation] = useState<any>(null);
const [refundAmount, setRefundAmount] = useState("0");
const [isCustomRefund, setIsCustomRefund] = useState(false);
const [cancellationReason, setCancellationReason] = useState("");
const [refundLoading, setRefundLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [selectedOrder, setSelectedOrder] =
    useState<ManagerScheduledOrder | null>(null);

  const [clinicDropdown, setClinicDropdown] = useState<ClinicOption[]>([]);
  const [selectedClinic, setSelectedClinic] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const clinicOptions = clinicDropdown.map((clinic) => ({
    value: clinic.clinicID,
    label: `${clinic.clinicName} - ID-${clinic.clinicID}`,
  }));

  const loadClinics = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const response = await apiAxios.get(
        `${API_BASE}/Manager/scheduled-order-clinics`,
        {
          headers: {
            AuthorizationData: token,
          },
        }
      );

      const rows = response.data?.data ?? [];

      setClinicDropdown(
        rows.map((clinic: any) => ({
          clinicID: clinic.clinicID ?? clinic.ClinicID,
          clinicName: clinic.clinicName ?? clinic.ClinicName,
        }))
      );
    } catch (error) {
      console.error("Error loading scheduled order clinics:", error);
      setClinicDropdown([]);
    }
  };

  const fetchScheduledOrders = useCallback(
    async (searchText = search) => {
      try {
        setLoading(true);

        const token = sessionStorage.getItem("token") || "";

        const response = await apiAxios.get(
          `${API_BASE}/Central/scheduled-orders`,
          {
            params: {
              search: searchText.trim() || undefined,
              clinicId: selectedClinic
                ? Number(selectedClinic)
                : undefined,
              fromDate: formatFilterDate(startDate),
              toDate: formatFilterDate(endDate),
            },
            headers: {
              AuthorizationData: token,
            },
          }
        );

        const result = response.data;

        if (!result?.isSuccess) {
          setOrders([]);
          toast.error(
            result?.status || "Failed to load scheduled orders"
          );
          return;
        }

        const rows = result.data ?? result.dataOne ?? [];

        setOrders(
          (Array.isArray(rows) ? rows : []).map(mapScheduledOrder)
        );
      } catch (error: any) {
        console.error("Error fetching scheduled orders:", error);
        setOrders([]);

        toast.error(
          error?.response?.data?.status ||
            "Failed to load scheduled orders"
        );
      } finally {
        setLoading(false);
      }
    },
    [search, selectedClinic, startDate, endDate]
  );

  useEffect(() => {
    loadClinics();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchScheduledOrders();
    }, 400);

    return () => clearTimeout(timer);
  }, [fetchScheduledOrders]);

  const handleClearFilters = () => {
    setSelectedClinic("");
    setStartDate(null);
    setEndDate(null);
    setSearch("");
  };

  const openOrderModal = (order: ManagerScheduledOrder) => {
    setSelectedOrder(order);
  };

  const handleCancelOrder = async () => {
  if (!selectedOrder) return;

  if (
    selectedOrder.status?.toLowerCase() === "cancelled" ||
    selectedOrder.status?.toLowerCase() === "completed"
  ) {
    toast.warning("This order cannot be cancelled.");
    return;
  }

  // try {
  //   const token = sessionStorage.getItem("token") || "";

  //   const res = await apiAxios.get(
  //     `/Dentist/refund-details/${selectedOrder.caseID}`,
  //     {
  //       headers: {
  //         AuthorizationData: token,
  //       },ax   sasdsgsy hrthfyt2
  //     }
  //   );djfjdfd fdf dfsdfk jdfs

    const orderToCancel = selectedOrder;

// Close the Order Details popup immediately
setSelectedOrder(null);

try {
  const token = sessionStorage.getItem("token") || "";

  const res = await apiAxios.get(
    `/Dentist/refund-details/${orderToCancel.caseID}`,
    {
      headers: {
        AuthorizationData: token,
      },
    }
  );

    if (res.data?.isSuccess) {
      const item = res.data.singleData;

      setSelectedCancellation(item);
      setRefundAmount(String(item.suggestedRefundAmount ?? 0));
      setIsCustomRefund(false);
      setCancellationReason("");
      setShowRefundModal(true);
    } else {
      toast.error(
        res.data?.message || "Unable to load refund details"
      );
    }
  } catch (error: any) {
    console.error("Error loading refund details:", error);

    toast.error(
      error?.response?.data?.message ||
      "Unable to load refund details"
    );
  }
};

const approveRefund = async () => {
  if (refundLoading || !selectedCancellation) return;

  const refund = Number(refundAmount);
  const paidAmount = Number(selectedCancellation.paidAmount || 0);

  if (!Number.isFinite(refund) || refund < 0 || refund > paidAmount) {
    toast.error(`Refund Amount must be between ₹0 and ₹${paidAmount}`);
    return;
  }

  if (paidAmount > 0 && refund < 1) {
    toast.error("Refund Amount must be at least ₹1.");
    return;
  }

  if (!cancellationReason.trim()) {
    toast.error("Please enter a cancellation reason.");
    return;
  }

  try {
    setRefundLoading(true);

    const token = sessionStorage.getItem("token") || "";

    const payload = {
      caseID: selectedCancellation.caseID,
      refundAmount: refund,
      isCustomRefund,
      cancellationReason: cancellationReason.trim(),
    };

    const res = await apiAxios.post(
      `/Dentist/cancel-approve`,
      payload,
      {
        headers: {
          AuthorizationData: token,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data?.isSuccess) {
      setShowRefundModal(false);
      setSelectedCancellation(null);
      setSelectedOrder(null);

      toast.success("Order cancelled successfully.");

      await fetchScheduledOrders();
    } else {
      toast.error(res.data?.message || "Cancellation failed.");
    }
  } catch (error: any) {
    console.error("Cancellation error:", error);

    toast.error(
      error?.response?.data?.message ||
      error?.response?.data?.data?.message ||
      "Cancellation failed."
    );
  } finally {
    setRefundLoading(false);
  }
};

  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: ManagerScheduledOrder) => row.orderId,
        sortable: true,
        width: "14%",
        wrap: true,
      },
      {
        name: "Type",
        selector: (row: ManagerScheduledOrder) => row.type,
        sortable: true,
        width: "14%",
        wrap: true,
      },
      {
        name: "Clinic / Phone",
        selector: (row: ManagerScheduledOrder) => row.clinic,
        cell: (row: ManagerScheduledOrder) => (
          <div
            className="d-flex flex-column py-2"
            style={{ lineHeight: "1.4", minWidth: 0 }}
          >
            <span
              className="fw-semibold"
              style={{
                fontSize: "14px",
                color: "#26364b",
                overflowWrap: "anywhere",
              }}
            >
              {row.clinic || "--"}
            </span>

            <span className="text-muted small mt-1">
              <i className="bi bi-telephone me-1" />
              {row.clinicMobileNo || "--"}
            </span>
          </div>
        ),
        sortable: true,
        width: "25%",
        wrap: true,
      },
      {
        name: "Schedule Date & Time",
        selector: (row: ManagerScheduledOrder) =>
          `${row.scheduleDate} ${row.scheduleTime}`,
        cell: (row: ManagerScheduledOrder) => (
          <div
            onClick={() => openOrderModal(row)}
            style={{
              cursor: "pointer",
              width: "100%",
              whiteSpace: "normal",
              lineHeight: "1.4",
            }}
          >
            <div>{formatScheduleDate(row.scheduleDate)}</div>

            <div className="text-muted small mt-1">
              <i className="bi bi-clock me-1" />
              {formatScheduleTime(row.scheduleTime)}
              {row.scheduleEndTime &&
                ` – ${formatScheduleTime(row.scheduleEndTime)}`}
            </div>
          </div>
        ),
        sortable: true,
        width: "25%",
        wrap: true,
      },
      {
        name: "Status",
        width: "22%",
        cell: (row: ManagerScheduledOrder) => {
          const item = STATUS_ITEMS.find(
            (status) => status.key === row.status
          );

          return (
            <span
              style={{
                ...getStatusStyle(row.status),
                padding: "5px 10px",
                borderRadius: "5px",
                fontSize: "12px",
                cursor: "pointer",
                whiteSpace: "normal",
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                maxWidth: "100%",
                overflowWrap: "anywhere",
              }}
              className="cursor-pointer"
              onClick={(event) => {
                event.stopPropagation();
                openOrderModal(row);
              }}
            >
              {item?.icon ? (
                <img
                  src={item.icon}
                  alt=""
                  className="status-icon"
                  style={{
                    width: 14,
                    height: 14,
                    flexShrink: 0,
                  }}
                />
              ) : (
                item?.iconClass && (
                  <i
                    className={item.iconClass}
                    style={{ fontSize: 12, lineHeight: 1 }}
                  />
                )
              )}

              <span>{row.status}</span>
            </span>
          );
        },
      },
    ],
    []
  );

  const customTableStyles = {
    table: {
      style: {
        width: "100%",
        minWidth: "100%",
      },
    },
    tableWrapper: {
      style: {
        width: "100%",
      },
    },
  
    headCells: {
      style: {
        paddingLeft: "14px",
        paddingRight: "14px",
        fontSize: "14px",
        fontWeight: 700,
        color: "#344054",
        whiteSpace: "normal" as const,
      },
    },
    cells: {
      style: {
        paddingLeft: "14px",
        paddingRight: "14px",
        paddingTop: "8px",
        paddingBottom: "8px",
        fontSize: "12px",
        color: "#344054",
        minWidth: "0",
        overflowWrap: "anywhere" as const,
      },
    },
    rows: {
      style: {
        minHeight: "58px",
        borderBottom: "1px solid #edf0f4",
      },
    
    },
    pagination: {
      style: {
        borderTop: "1px solid #edf0f4",
        paddingTop: "10px",
        fontSize: "12px",
      },
    },
  };

  return (
    <div className="manager-schedule-page mt-1">
      {/* Page heading */}
      <div className="manager-schedule-heading mb-3">
        <div>
          <h4 className="mb-1">Schedule Orders List</h4>
          <p className="mb-0">
            View scheduled orders, clinics and payment details.
          </p>
        </div>

        {/* <div className="manager-order-count">
          <i className="bi bi-clipboard2-check me-2" />
          {orders.length} Orders
        </div> */}
      </div>

      {/* Search and filters */}
      <div className="manager-filter-card shadow-container rounded mb-3">
       

        <div className="manager-filter-body">
          {/* Search stays above the table */}
         

          <div className="row g-3 align-items-end">
            {/* Clinic filter */}
            <div className="col-12 col-md-4">
              <label className="form-label" htmlFor="managerClinicFilter">
                Select Clinic
              </label>

              <Select
                inputId="managerClinicFilter"
                options={clinicOptions}
                value={
                  clinicOptions.find(
                    (option) =>
                      String(option.value) === String(selectedClinic)
                  ) ?? null
                }
                onChange={(option) => {
                  setSelectedClinic(
                    option ? String(option.value) : ""
                  );
                }}
                placeholder="Select Clinic"
                isClearable
                isSearchable
                noOptionsMessage={() => "No clinics found"}
                menuPortalTarget={
                  typeof document !== "undefined"
                    ? document.body
                    : undefined
                }
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (base, state) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "7px",
                    borderColor: state.isFocused
                      ? "#3D8BFD"
                      : "#dce2ea",
                    boxShadow: state.isFocused
                      ? "0 0 0 3px rgba(61,139,253,0.12)"
                      : "none",
                    "&:hover": {
                      borderColor: "#3D8BFD",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    paddingLeft: "12px",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#98a2b3",
                    fontSize: "13px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "13px",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "13px",
                    backgroundColor: state.isSelected
                      ? "#3D8BFD"
                      : state.isFocused
                        ? "#eef5ff"
                        : "#fff",
                    color: state.isSelected ? "#fff" : "#344054",
                    cursor: "pointer",
                  }),
                }}
              />
            </div>

            {/* From date */}
            <div className="col-12 col-md-3">
              <label className="form-label" htmlFor="managerFromDate">
                From Date
              </label>

              <div className="manager-datepicker-wrap">
                <DatePicker
                  id="managerFromDate"
                  selected={startDate}
                  onChange={(date: Date | null) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={endDate ?? undefined}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                  className="form-control manager-datepicker-input"
                  isClearable
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  wrapperClassName="manager-datepicker-wrapper"
                  popperClassName="manager-datepicker-popper"
                  popperPlacement="bottom-start"
                  autoComplete="off"
                />

                <i
                  className="bi bi-calendar3 manager-datepicker-icon"
                  aria-hidden="true"
                />
              </div>
            </div>

            {/* To date */}
            <div className="col-12 col-md-3">
              <label className="form-label" htmlFor="managerToDate">
                To Date
              </label>

              <div className="manager-datepicker-wrap">
                <DatePicker
                  id="managerToDate"
                  selected={endDate}
                  onChange={(date: Date | null) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate ?? undefined}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                  className="form-control manager-datepicker-input"
                  isClearable
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  wrapperClassName="manager-datepicker-wrapper"
                  popperClassName="manager-datepicker-popper"
                  popperPlacement="bottom-start"
                  autoComplete="off"
                />

                <i
                  className="bi bi-calendar3 manager-datepicker-icon"
                  aria-hidden="true"
                />
              </div>
            </div>

            {/* Clear filters */}
            <div className="col-12 col-md-2">
              <button
                type="button"
                className="btn manager-clear-filter-btn w-100"
                onClick={handleClearFilters}
                disabled={loading}
              >
                <i className="bi bi-arrow-counterclockwise me-2" />
                Clear Filters
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Orders table */}
      <div className="manager-orders-card shadow-container rounded mt-3">
        {/* <div className="manager-table-heading">
          <div>
            <h6 className="mb-1">Scheduled Orders</h6>
            <p className="mb-0">
              {loading
                ? "Loading orders..."
                : `${orders.length} order(s) found`}
            </p>
          </div>

          <span className="manager-table-heading-icon">
            <i className="bi bi-table" />
          </span>
        </div> */}

        <div className="manager-table-container">
          <div className="row">
                <div className="col-md-9">
                  </div>
            <div className="col-md-3">
               <div className="manager-search-wrap mb-3">
            <label htmlFor="managerOrderSearch" className="form-label">
              Search Orders
            </label>

            <div className="input-group manager-search-input">
              <span className="input-group-text">
                <i className="bi bi-search" />
              </span>

              <input
                id="managerOrderSearch"
                type="text"
                className="form-control"
                placeholder="Search by Order ID, Clinic, Type..."
                value={search}
                onChange={(event) => setSearch(event.target.value)}
              />

              {search && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  title="Clear search"
                  aria-label="Clear search"
                  onClick={() => setSearch("")}
                >
                  <i className="bi bi-x-lg" />
                </button>
              )}
            </div>
          </div>
              </div>
            </div>
          <DataTable
            columns={columns}
            data={orders}
            progressPending={loading}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            highlightOnHover
            responsive
            selectableRows={false}
            pointerOnHover
            onRowClicked={openOrderModal}
            customStyles={customTableStyles}
            noDataComponent={
              <div className="manager-no-orders">
                <i className="bi bi-inbox" />
                <h6>No schedule orders found</h6>
                <p className="mb-0">
                  Try changing your search or filter criteria.
                </p>
              </div>
            }
          />
        </div>
      </div>

      {/* Order details modal */}
      {selectedOrder && (
        <div
          className="modal fade show d-block manager-order-modal"
          style={{ backgroundColor: "rgba(15, 23, 42, 0.55)" }}
          onClick={() => setSelectedOrder(null)}
        >
          <div
            className="modal-dialog modal-dialog-centered admin-order-modal-dialog"
            style={{ maxWidth: "980px" }}
            onClick={(event) => event.stopPropagation()}
          >
            <div
              className="modal-content custom-modal-padding15px"
              style={{ minHeight: "580px" }}
            >
              <div className="modal-header manager-modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title mb-0">
                  Order Details: {selectedOrder.orderId}
                </h5>

                <button
                  type="button"
                  className="custom-close-btn3"
                  aria-label="Close"
                  onClick={() => setSelectedOrder(null)}
                >
                  <i className="bi bi-x customcross" />
                </button>
              </div>

           <div className="modal-body p-0">
  <OrderStatusContent orderDetails={selectedOrder} />

  <div className="px-4">
    <button
      type="button"
      className="btn w-100 rounded-0 border-0 border-bottom py-3 fw-semibold"
      onClick={handleCancelOrder}
      disabled={
        selectedOrder.status === "Cancelled" ||
        selectedOrder.status === "Completed"
      }
      style={{
        color: "#343a40",
        backgroundColor: "#fff",
      }}
    >
      Cancel Order
    </button>
  </div>
</div>
            </div>
          </div>
        </div>
      )}

      {showRefundModal && selectedCancellation && (
  <div
    className="modal-overlay"
    style={{ zIndex: 1060 }}
  >
    <div
      className="custom-modal"
      style={{ maxWidth: "520px", width: "95%" }}
    >
      <div className="modal-header manager-modal-header d-flex justify-content-between align-items-center">
        <h5 className="modal-title mb-0">
          Approve Cancellation
        </h5>

        <button
          type="button"
          className="custom-close-btn3"
          onClick={() => setShowRefundModal(false)}
          disabled={refundLoading}
          aria-label="Close"
        >
          <i className="bi bi-x customcross" />
        </button>
      </div>

      <div className="p-3">
        <div className="d-flex justify-content-between py-2 border-bottom">
          <span>Paid Amount</span>
          <strong>₹{selectedCancellation.paidAmount}</strong>
        </div>

        <div className="d-flex justify-content-between py-2 border-bottom">
          <span>Deduction</span>
          <strong className="text-danger">
            ₹{selectedCancellation.deductionAmount}
          </strong>
        </div>

        <div className="d-flex justify-content-between py-2 border-bottom">
          <span>Suggested Refund</span>
          <strong className="text-success">
            ₹{selectedCancellation.suggestedRefundAmount}
          </strong>
        </div>

        {selectedCancellation.allowCustomRefund && (
          <div className="form-check mt-3">
            <input
              id="customRefund"
              className="form-check-input"
              type="checkbox"
              checked={isCustomRefund}
              onChange={(e) => {
                setIsCustomRefund(e.target.checked);

                if (!e.target.checked) {
                  setRefundAmount(
                    String(selectedCancellation.suggestedRefundAmount ?? 0)
                  );
                }
              }}
            />
            <label className="form-check-label" htmlFor="customRefund">
              Custom Refund
            </label>
          </div>
        )}

        <label className="form-label mt-3">
          Refund Amount
        </label>

        <input
          type="number"
          className="form-control"
          min={Number(selectedCancellation.paidAmount) > 0 ? 1 : 0}
          max={selectedCancellation.paidAmount}
          value={refundAmount}
          disabled={!isCustomRefund || refundLoading}
          onChange={(e) => setRefundAmount(e.target.value)}
        />

        <label className="form-label mt-3">
          Cancellation Reason
        </label>

        <textarea
          className="form-control"
          rows={3}
          value={cancellationReason}
          onChange={(e) => setCancellationReason(e.target.value)}
          placeholder="Enter cancellation reason"
          disabled={refundLoading}
        />

        <div className="mt-3 text-end">
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={() => setShowRefundModal(false)}
            disabled={refundLoading}
          >
            Close
          </button>

          <button
            type="button"
            className="btn btn-danger"
            onClick={approveRefund}
            disabled={refundLoading}
          >
            {refundLoading ? "Processing..." : "Confirm Cancellation"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default ScheduleOrders;
